/* ========================================================================
   SWF Savings Quiz — shared JS
   Included via {{ 'swf-quiz.js' | asset_url | script_tag }} in each section
   that needs JS — the tag is NOT deduped, so this file's top-level body
   executes once per section that includes it. The bootstrap guard below
   makes that re-execution a no-op past the first run.

   Pattern: each section emits a small inline <script> that pushes its
   per-section config onto `window.SWFQuizConfig`. After DOMContentLoaded,
   this file reads those configs and bootstraps the corresponding subsystem.

   Subsystems:
   - wizard       (owns window.SWFQuiz state + pub/sub)
   - hero         (rotating ticker + sticky nav-counter)
   - results      (bar chart + animated savings counter)
   - equivalents  ("What that money looks like" cards)
   ======================================================================== */
(function () {
  'use strict';

  if (window.__swfQuizBootstrapped) return;
  window.__swfQuizBootstrapped = true;

  window.SWFQuizConfig = window.SWFQuizConfig || {};

  function ready (fn) {
    if (document.readyState !== 'loading') return fn();
    document.addEventListener('DOMContentLoaded', fn);
  }

  function fmt (n) { return '$' + Math.round(n).toLocaleString('en-US'); }

  /* ---------------------------------------------------------------- */
  /* Wizard — owns window.SWFQuiz                                     */
  /* ---------------------------------------------------------------- */
  function initWizard (cfg) {
    if (!cfg) return;
    var sec = document.getElementById('shopify-section-' + cfg.sectionId) || document;
    function $ (sel) { return sec.querySelector(sel); }
    function $$ (sel) { return Array.prototype.slice.call(sec.querySelectorAll(sel)); }

    var PRICE         = cfg.PRICE;
    var SCALE_CONFIG  = cfg.SCALE_CONFIG;
    var DECOR_CONFIG  = cfg.DECOR_CONFIG;
    var defaults      = cfg.defaults || { bridesmaids: 5, groomsmen: 5, family: 4 };
    var klaviyoListId = cfg.klaviyoListId;

    var state = {
      step: 1,
      answers: {
        bridesmaids: defaults.bridesmaids,
        groomsmen:   defaults.groomsmen,
        family:      defaults.family,
        scale:       'traditional',
        decor:       'medium',
        email: '',
        date: ''
      },
      revealed: false
    };

    /* Tiny pub/sub */
    var listeners = {};
    function on (evt, fn) { (listeners[evt] = listeners[evt] || []).push(fn); }
    function emit (evt, data) {
      (listeners[evt] || []).forEach(function (fn) {
        try { fn(data); } catch (e) { /* swallow */ }
      });
    }

    function computeTotals () {
      var a = state.answers;
      var c = SCALE_CONFIG[a.scale] || SCALE_CONFIG.traditional;
      var dec = DECOR_CONFIG[a.decor] || DECOR_CONFIG.medium;
      var fresh = 0, sola = 0;
      fresh += PRICE.bridal.fresh; sola += PRICE.bridal.sola;
      fresh += a.bridesmaids * PRICE.bridesmaid.fresh;
      sola  += a.bridesmaids * PRICE.bridesmaid.sola;
      var bouts = a.groomsmen + (a.groomsmen > 0 ? 1 : 0);
      fresh += bouts * PRICE.boutonniere.fresh;
      sola  += bouts * PRICE.boutonniere.sola;
      fresh += a.family * PRICE.family.fresh;
      sola  += a.family * PRICE.family.sola;
      fresh += c.centerpieces * PRICE.centerpiece.fresh;
      sola  += c.centerpieces * PRICE.centerpiece.sola;
      if (dec.arch)    { fresh += PRICE.archGreen.fresh;     sola += PRICE.archGreen.sola; }
      if (dec.aisle)   { fresh += dec.aisle * PRICE.aisleMarker.fresh; sola += dec.aisle * PRICE.aisleMarker.sola; }
      if (dec.ceiling) { fresh += PRICE.ceilingInstall.fresh; sola += PRICE.ceilingInstall.sola; }
      var savings = Math.max(0, fresh - sola);
      var pct = fresh > 0 ? Math.round((savings / fresh) * 100) : 0;
      return { fresh: fresh, sola: sola, savings: savings, pct: pct, centerpieces: c.centerpieces };
    }

    /* Expose globally for downstream sections */
    window.SWFQuiz = {
      state: state,
      PRICE: PRICE,
      SCALE_CONFIG: SCALE_CONFIG,
      DECOR_CONFIG: DECOR_CONFIG,
      computeTotals: computeTotals,
      on: on,
      emit: emit
    };

    function updateLiveCounter () {
      var t = computeTotals();
      var c = $('#swf-quiz-counter-amt'); if (c) c.textContent = fmt(t.savings);
      var pre = $('#swf-quiz-prereveal-amt'); if (pre) pre.textContent = fmt(t.savings);
      emit('change', t);
    }

    function goToStep (n) {
      state.step = n;
      $$('.swf-quiz-wizard-step').forEach(function (el) {
        el.classList.toggle('active', Number(el.getAttribute('data-step')) === n);
      });
      $$('.swf-quiz-wizard-dot').forEach(function (d) {
        var ds = Number(d.getAttribute('data-step'));
        d.classList.toggle('active', ds === n);
        d.classList.toggle('done', ds < n);
      });
      var back = $('#swf-quiz-back'); if (back) back.disabled = (n === 1);
      var nextBtn = $('#swf-quiz-next');
      if (nextBtn) nextBtn.textContent = (n === 5) ? 'See my savings →' : 'Next →';
    }

    function bindSlider (id, key, valId) {
      var input = sec.querySelector('#' + id);
      var valEl = sec.querySelector('#' + valId);
      if (!input || !valEl) return;
      function paint () {
        var pct = ((input.value - input.min) / (input.max - input.min)) * 100;
        input.style.setProperty('--pct', pct + '%');
        valEl.textContent = input.value;
        state.answers[key] = Number(input.value);
        updateLiveCounter();
      }
      input.addEventListener('input', paint);
      paint();
    }
    bindSlider('swf-quiz-bridesmaids', 'bridesmaids', 'swf-quiz-bridesmaids-val');
    bindSlider('swf-quiz-groomsmen',   'groomsmen',   'swf-quiz-groomsmen-val');
    bindSlider('swf-quiz-family',      'family',      'swf-quiz-family-val');

    $$('.swf-quiz-wizard-tile').forEach(function (t) {
      t.addEventListener('click', function () {
        var q = t.getAttribute('data-q');
        $$('.swf-quiz-wizard-tile[data-q="' + q + '"]').forEach(function (x) {
          x.classList.remove('active');
          x.setAttribute('aria-checked', 'false');
        });
        t.classList.add('active');
        t.setAttribute('aria-checked', 'true');
        state.answers[q] = t.getAttribute('data-value');
        updateLiveCounter();
      });
    });

    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var emailInput = $('#swf-quiz-email');
    var emailError = $('#swf-quiz-email-error');
    if (emailInput) emailInput.addEventListener('input', function (e) {
      state.answers.email = e.target.value;
      if (emailError) emailError.hidden = true;
    });
    var dt = $('#swf-quiz-wedding-date');
    if (dt) dt.addEventListener('change', function (e) { state.answers.date = e.target.value; });

    function submitToKlaviyo () {
      if (!klaviyoListId || typeof fetch !== 'function') return;
      var body = 'g=' + encodeURIComponent(klaviyoListId) +
        '&email=' + encodeURIComponent(state.answers.email) +
        '&weddingDate=' + encodeURIComponent(state.answers.date);
      try {
        fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
          method: 'POST',
          mode: 'no-cors',
          keepalive: true,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: body
        });
      } catch (e) { /* best-effort — never block the reveal */ }
    }

    var nextBtn = $('#swf-quiz-next');
    if (nextBtn) nextBtn.addEventListener('click', function () {
      if (state.step === 4 && !EMAIL_RE.test(state.answers.email)) {
        if (emailError) emailError.hidden = false;
        if (emailInput) emailInput.focus();
        return;
      }
      if (state.step < 5) goToStep(state.step + 1);
      else {
        state.revealed = true;
        submitToKlaviyo();
        var t = computeTotals();
        emit('reveal', t);
      }
    });
    var backBtn = $('#swf-quiz-back');
    if (backBtn) backBtn.addEventListener('click', function () {
      if (state.step > 1) goToStep(state.step - 1);
    });

    goToStep(1);
    updateLiveCounter();
  }

  /* ---------------------------------------------------------------- */
  /* Hero — rotating ticker + sticky nav-counter                      */
  /* ---------------------------------------------------------------- */
  function initHero (cfg) {
    if (!cfg) return;

    var TICKER_VALUES = cfg.tickerValues;
    try { TICKER_VALUES = (typeof TICKER_VALUES === 'string') ? JSON.parse(TICKER_VALUES) : TICKER_VALUES; }
    catch (e) { TICKER_VALUES = ['$2,950', '$1,420', '$5,180', '$3,640', '$4,210']; }
    if (!TICKER_VALUES || !TICKER_VALUES.length) TICKER_VALUES = ['$2,950', '$1,420', '$5,180', '$3,640', '$4,210'];

    var tickerEl = document.getElementById('swf-quiz-hero-ticker');
    var navCounter = document.getElementById('swf-quiz-nav-counter');
    var navAmt = document.getElementById('swf-quiz-nav-counter-amt');
    var ti = 0;
    var revealed = false;

    if (tickerEl) {
      setInterval(function () {
        if (revealed) return;
        ti = (ti + 1) % TICKER_VALUES.length;
        tickerEl.style.opacity = '0';
        setTimeout(function () {
          tickerEl.textContent = TICKER_VALUES[ti];
          tickerEl.style.opacity = '1';
        }, 220);
      }, 2400);
    }

    function bindToQuiz () {
      if (!window.SWFQuiz || typeof window.SWFQuiz.on !== 'function') return false;
      window.SWFQuiz.on('change', function (t) {
        if (t && typeof t.savings === 'number' && t.savings > 0 && navCounter && navAmt) {
          navCounter.classList.add('live');
          navAmt.textContent = '$' + Math.round(t.savings).toLocaleString('en-US');
        }
      });
      window.SWFQuiz.on('reveal', function () { revealed = true; });
      return true;
    }
    if (!bindToQuiz()) {
      var attempts = 0;
      var iv = setInterval(function () {
        attempts++;
        if (bindToQuiz() || attempts > 40) clearInterval(iv);
      }, 150);
    }
  }

  /* ---------------------------------------------------------------- */
  /* Results — bar chart + animated savings counter                   */
  /* ---------------------------------------------------------------- */
  function initResults (cfg) {
    if (!cfg) return;
    var sec = document.getElementById('shopify-section-' + cfg.sectionId);
    if (!sec) return;

    function renderTotals (t) {
      if (!t) return;
      var pctEl = sec.querySelector('#swf-quiz-results-pct');
      if (pctEl) pctEl.textContent = 'Save ' + t.pct + '% vs. fresh';
      var freshV = sec.querySelector('#swf-quiz-bar-fresh-v');
      var solaV  = sec.querySelector('#swf-quiz-bar-sola-v');
      if (freshV) freshV.textContent = fmt(t.fresh);
      if (solaV)  solaV.textContent  = fmt(t.sola);
      var amt = sec.querySelector('#swf-quiz-results-amt');
      if (amt) amt.textContent = fmt(t.savings);
    }

    function animateCounter (el, from, to, ms) {
      var start = performance.now();
      var reduceMotion = (typeof window.matchMedia === 'function')
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) { el.textContent = fmt(to); return; }
      function tick (now) {
        var t = Math.min(1, (now - start) / ms);
        var eased = 1 - Math.pow(1 - t, 3);
        var v = from + (to - from) * eased;
        el.textContent = fmt(v);
        if (t < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    function chooseTier (solaTotal) {
      if (solaTotal < 600) return 'good';
      if (solaTotal < 950) return 'better';
      return 'best';
    }

    function reveal (t) {
      sec.classList.add('swf-quiz-show');
      renderTotals(t);

      var sq = window.SWFQuiz;
      if (sq && sq.state && sq.state.answers) {
        var bm = sec.querySelector('#swf-quiz-bullet-bm');
        var gm = sec.querySelector('#swf-quiz-bullet-gm');
        if (bm) bm.textContent = sq.state.answers.bridesmaids;
        if (gm) gm.textContent = sq.state.answers.groomsmen + (sq.state.answers.groomsmen > 0 ? 1 : 0);
      }

      var max = t.fresh || 1;
      setTimeout(function () {
        var f = sec.querySelector('#swf-quiz-bar-fresh');
        var s = sec.querySelector('#swf-quiz-bar-sola');
        if (f) f.style.width = '100%';
        if (s) s.style.width = ((t.sola / max) * 100) + '%';
      }, 80);

      var amt = sec.querySelector('#swf-quiz-results-amt');
      if (amt) {
        try { animateCounter(amt, 0, t.savings, 1100); } catch (e) { amt.textContent = fmt(t.savings); }
      }

      // CTA — append quiz state for downstream filtering
      var cta = sec.querySelector('#swf-quiz-results-cta');
      if (cta && sq && sq.state) {
        var a = sq.state.answers;
        var params = new URLSearchParams({
          tier: chooseTier(t.sola),
          bridesmaids: a.bridesmaids,
          groomsmen: a.groomsmen,
          scale: a.scale,
          decor: a.decor,
          from: 'savings-quiz'
        });
        var base = cta.getAttribute('href') || '#';
        var sep  = base.indexOf('?') === -1 ? '?' : '&';
        cta.setAttribute('href', base + sep + params.toString());
      }

      setTimeout(function () {
        if (sec && typeof sec.scrollIntoView === 'function') {
          sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 80);
    }

    function bindToQuiz () {
      if (!window.SWFQuiz || typeof window.SWFQuiz.on !== 'function') return false;
      window.SWFQuiz.on('change', renderTotals);
      window.SWFQuiz.on('reveal', reveal);
      try { renderTotals(window.SWFQuiz.computeTotals()); } catch (e) { /* noop */ }
      return true;
    }
    if (!bindToQuiz()) {
      var attempts = 0;
      var iv = setInterval(function () {
        attempts++;
        if (bindToQuiz() || attempts > 40) clearInterval(iv);
      }, 150);
    }
  }

  /* ---------------------------------------------------------------- */
  /* Equivalents — "what that money looks like"                       */
  /* ---------------------------------------------------------------- */
  function initEquivalents (cfg) {
    if (!cfg) return;
    var sec = document.getElementById('shopify-section-' + cfg.sectionId);
    if (!sec) return;

    function trimZero (s) { return s.replace(/\.0+$/, ''); }

    function update (savings) {
      if (typeof savings !== 'number') return;
      var amtEl = sec.querySelector('#swf-quiz-equiv-amt');
      if (amtEl) amtEl.textContent = fmt(savings);

      var cards = sec.querySelectorAll('.swf-quiz-equiv-card');
      Array.prototype.forEach.call(cards, function (card) {
        var divisor = parseFloat(card.getAttribute('data-divisor')) || 1;
        var mode    = card.getAttribute('data-mode') || 'decimal';
        var n = savings / divisor;
        var out;
        if (mode === 'integer') out = String(Math.round(n));
        else                    out = trimZero(n.toFixed(1));
        var numEl = card.querySelector('.swf-quiz-equiv-num');
        if (numEl) numEl.textContent = out;
      });
    }

    function reveal (t) {
      sec.classList.add('swf-quiz-show');
      if (t && typeof t.savings === 'number') update(t.savings);
    }

    function onChange (t) {
      if (t && typeof t.savings === 'number') update(t.savings);
    }

    function bindToQuiz () {
      if (!window.SWFQuiz || typeof window.SWFQuiz.on !== 'function') return false;
      window.SWFQuiz.on('change', onChange);
      window.SWFQuiz.on('reveal', reveal);
      try { update(window.SWFQuiz.computeTotals().savings); } catch (e) { /* noop */ }
      return true;
    }
    if (!bindToQuiz()) {
      var attempts = 0;
      var iv = setInterval(function () {
        attempts++;
        if (bindToQuiz() || attempts > 40) clearInterval(iv);
      }, 150);
    }
  }

  /* ---------------------------------------------------------------- */
  /* Bootstrap                                                        */
  /* ---------------------------------------------------------------- */
  ready(function () {
    var cfg = window.SWFQuizConfig || {};
    // Wizard MUST initialize first so window.SWFQuiz is available before
    // other subsystems call bindToQuiz().
    if (cfg.wizard)      initWizard(cfg.wizard);
    if (cfg.hero)        initHero(cfg.hero);
    if (cfg.results)     initResults(cfg.results);
    if (cfg.equivalents) initEquivalents(cfg.equivalents);
  });
})();
